import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=1d6cc7f4"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"
import style0 from "./MainFooter.vue?vue&type=style&index=0&id=1d6cc7f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports